import { BaseTexture, ExtensionType, Texture } from '@pixi/core';
import { getResolutionOfUrl } from '@pixi/utils';
import type { Loader, LoadAsset } from '@pixi/assets';

import type { LoaderParser } from '@pixi/assets';

const validImages = ['jpg', 'png', 'jpeg', 'avif', 'webp'];


export type LoadTextureData = {
	baseTexture: BaseTexture;
};

/**
 * An exact copy of Pixi's loadTextures extension but without the use of
 * imageBitmaps.
 */
export const loadTexturesUsingImageSource = {
	extension: ExtensionType.LoadParser,

	test(url: string): boolean {
		const tempURL = url.split('?')[0];
		const extension = tempURL.split('.').pop()!;

		return validImages.includes(extension);
	},

	async load(url: string, asset: LoadAsset<LoadTextureData>, loader: Loader): Promise<Texture> {
		const src = await new Promise<HTMLImageElement>((resolve) => {
			const src = new Image();
			src.crossOrigin = 'anonymous';

			src.src = url;
			if (src.complete) {
				resolve(src);
			} else {
				src.onload = (): void => {
					resolve(src);
				};
			}
		});

		const base = new BaseTexture(src, {
			resolution: getResolutionOfUrl(url),
			...asset.data,
		});

		base.resource.src = url;

		const texture = new Texture(base);

        // make sure to nuke the promise if a texture is destroyed..
		texture.baseTexture.on('dispose', () => {
			delete loader.promiseCache[url];
		});

		return texture;
	},

	unload(texture: Texture): void {
		texture.destroy(true);
	}

} as LoaderParser<Texture, LoadTextureData>;
